<template>
  <b-modal
    id="forget-password-sent-modal"
    ref="forget-password-sent-modal"
    centered
    hide-header
    modal-class="coop-modal"
  >
    <button
      type="button"
      class="modal-close-button"
      @click.prevent="closeModal"
    >
      <img src="~assets/images/close-button.svg">
    </button>
    <div class="modal-title-holder">
      <div class="text-center">
        <img src="/images/forgot-password-sent.svg">
      </div>
      <br>
      <br>
      <h1
        class="modal-title confirm-booking-title text-center"
      >
        EMAIL SENT!
      </h1>
      <h2 class="sub-title text-center">
        Please check your email so you can create your new password
      </h2>
      <br>
      <br>
    </div>
    <template slot="modal-footer">
      <button
        type="button"
        class="button -block"
        @click.prevent="onClose"
      >
        OK
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    openModal () {
      if (this.$refs['forget-password-sent-modal']) {
        this.$refs['forget-password-sent-modal'].show()
      }
    },
    closeModal () {
      if (this.$refs['forget-password-sent-modal']) {
        this.$refs['forget-password-sent-modal'].hide()
      }
    },
    onClose () {
      this.closeModal()
    }
  }
}
</script>
